var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('StudioHeader'),_c('main',{staticClass:"main"},[_c('StudioIntro'),_c('div',{staticClass:"main__inner"},[_c('router-view')],1)],1),_c('StudioFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }